import composeReducers from '../composeReducers';
import simulateur from './simulateur';
import simulateurReverse from './simulateurReverse';
export default composeReducers(simulateurReverse, simulateur);
